import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/style';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './shadcn/Dialog';

export type ModalWindowWidth = 'default' | 'large';

export interface ModalOpeningProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  windowWidth?: ModalWindowWidth;
}

export type ModalProps = PropsWithChildren<
  ModalOpeningProps & {
    title: string;
  }
>;

export function Modal(props: PropsWithChildren<ModalProps>) {
  const { title, open, onOpenChange, children, windowWidth } = props;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn('min-w-[60vw]', {
          'min-w-[80vw]': windowWidth === 'large',
        })}
        onClick={(event) => event.stopPropagation()}
        aria-describedby={undefined}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2 max-h-[80vh] overflow-y-auto">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
